import React, { useState } from 'react';
import {
    Modal,
    DataTable,
    Table,
    TableHead,
    TableRow,
    TableHeader,
    TableBody,
    TableCell,
    TableExpandRow,
    TableExpandedRow,
    TableSelectAll,
    TableSelectRow,
    TableContainer,
    TableExpandHeader,
    Pagination,
} from 'carbon-components-react';

type Props = {
    open: boolean;
    onClose: () => void;
    // onSubmit: (folder: any) => void;
};

type Task = {
    id: string;
    name: string;
    progress: number;
    status: string;
    priority: string;
    createdAt: string;
    startTime: string;
    eta: string;
    system: string;
    details: string;
};

const headers = [
    { key: 'name', header: 'Name' },
    // { key: 'progress', header: 'Progress' },
    { key: 'status', header: 'Action' },
    { key: 'priority', header: 'Template' },
    { key: 'createdAt', header: 'Queued' },
    // { key: 'startTime', header: 'Start Time' },
    // { key: 'eta', header: 'ETA' },
    // { key: 'system', header: 'System' },
];

const tasks: Task[] = [
    {
        id: '1',
        name: 'Database Migration',
        progress: 90,
        status: 'Running',
        priority: 'High',
        createdAt: '2025-06-01',
        startTime: '09:00',
        eta: '11:30',
        system: 'CoreDB',
        details: 'Migration from SQL Server to PostgreSQL.',
    },
    {
        id: '2',
        name: 'Backup Sync',
        progress: 100,
        status: 'Completed',
        priority: 'Medium',
        createdAt: '2025-06-02',
        startTime: '13:00',
        eta: '14:00',
        system: 'FileStorage',
        details: 'Daily sync of backup snapshots.',
    },
    {
        id: '3',
        name: 'Security Scan',
        progress: 45,
        status: 'Pending',
        priority: 'High',
        createdAt: '2025-06-03',
        startTime: '15:00',
        eta: '17:00',
        system: 'WebServer',
        details: 'Scanning for vulnerabilities.',
    },
    {
        id: '4',
        name: 'Server Provisioning',
        progress: 60,
        status: 'Running',
        priority: 'Low',
        createdAt: '2025-06-04',
        startTime: '10:00',
        eta: '13:00',
        system: 'Cluster-B',
        details: 'Automated provisioning of dev servers.',
    },
];



export const HistoryModal: React.FC<Props> = ({ open, onClose }) => {
    const handleSubmit = () => {
        // onSubmit(formData);
        onClose();
    };

    const [currentPage, setCurrentPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(10);


    const totalItems = tasks.length;
    const startIndex = (currentPage - 1) * rowsPerPage;
    const endIndex = startIndex + rowsPerPage;


    return (
        <Modal
            open={open}
            modalHeading="History"
            primaryButtonText="Close"
            // secondaryButtonText="Cancel"
            onRequestClose={onClose}
            onRequestSubmit={handleSubmit}
            size="lg"
            preventCloseOnClickOutside={true}
        >
            <div>
                <TableContainer>
                    <DataTable
                        rows={tasks}
                        headers={headers}
                        isSortable
                        render={({
                            rows,
                            headers,
                            getHeaderProps,
                            getRowProps,
                            getTableProps,
                            getSelectionProps,
                            getExpandHeaderProps,
                            getExpandRowProps,
                        }) => (
                            <Table {...getTableProps()}>
                                <TableHead>
                                    <TableRow>
                                        <TableExpandHeader {...getExpandHeaderProps()} />
                                        <TableSelectAll {...getSelectionProps()} />
                                        {headers.map((header) => (
                                            <TableHeader key={header.key} {...getHeaderProps({ header })}>
                                                {header.header}
                                            </TableHeader>
                                        ))}
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {rows.map((row) => (
                                        <React.Fragment key={row.id}>
                                            <TableExpandRow {...getRowProps({ row })}>
                                                <TableSelectRow {...getSelectionProps({ row })} />
                                                {/* {row.status} */}
                                                {row.cells.map((cell) => {
                                                    if (cell.info.header === 'progress') {
                                                        // const statusClass = getStatusClass(row.cells.find(cell => cell.id === row.id + ":status").value);
                                                        const value = row.progress;

                                                        return (
                                                            <TableCell key={cell.id}>
                                                                <div className="progress-bar-container">
                                                                    <div className={`progress-bar`}>
                                                                        <div
                                                                            className="progress-bar-fill"
                                                                            style={{ width: `${cell.value}%` }}
                                                                        />
                                                                    </div>
                                                                    {/* <div className="progress-label">{cell.value}%</div> */}
                                                                </div>
                                                            </TableCell>
                                                        );
                                                    }
                                                    return <TableCell key={cell.id}>{cell.value}</TableCell>;
                                                })}


                                            </TableExpandRow>
                                            <TableExpandedRow colSpan={headers.length + 2}>
                                                <div className="bx--grid">
                                                    <div className="bx--row">
                                                        <div className="bx--col-lg-12">
                                                            <strong>Details:</strong> {row.name}
                                                        </div>
                                                    </div>
                                                </div>
                                            </TableExpandedRow>
                                        </React.Fragment>
                                    ))}
                                </TableBody>
                            </Table>
                        )}
                    />

                    <Pagination
                        totalItems={totalItems}
                        pageSize={rowsPerPage}
                        pageSizes={[5, 10, 20, 50]}
                        page={currentPage}
                        onChange={({ page, pageSize }) => {
                            setCurrentPage(page);
                            setRowsPerPage(pageSize);
                        }}
                    />

                </TableContainer>
            </div>
        </Modal>
    );
};
